import { ref, onBeforeUnmount } from 'vue'
import { downloadBlobUrl } from '@/lib/utils'
import { useShare } from '@/composables/share'

export const usePdfPreview = (loadBlobUrlAsync) => {
  const blobUrl = ref(null)
  const source = ref(null)
  const isLoading = ref(false)
  const isPrinting = ref(false)
  const { shareFileAsync } = useShare()

  const revoke = () => {
    if (blobUrl.value) window.URL.revokeObjectURL(blobUrl.value)
    blobUrl.value = null
  }

  let latestRequest = 0
  const refreshAsync = async() => {
    const request = ++latestRequest
    revoke()
    source.value = null
    isLoading.value = true
    try {
      const url = await loadBlobUrlAsync()
      if (request !== latestRequest) {
        window.URL.revokeObjectURL(url)
        return
      }
      blobUrl.value = url
      source.value = await (await fetch(url)).arrayBuffer()
    } finally {
      if (request === latestRequest) isLoading.value = false
    }
  }

  const download = (fileName) => downloadBlobUrl(blobUrl.value, fileName)
  const printAsync = async(fileName, title) => {
    isPrinting.value = true
    try {
      return await shareFileAsync(blobUrl.value, fileName, title)
    } finally {
      isPrinting.value = false
    }
  }

  onBeforeUnmount(revoke)

  return { blobUrl, source, isLoading, isPrinting, refreshAsync, download, printAsync }
}
